<template >
	<v-tabs next-icon="mdi-arrow-right-bold-box-outline" v-model="tab" prev-icon="mdi-arrow-left-bold-box-outline" show-arrows="show-arrows">
        <v-tabs-slider color="blue-grey darken-3"></v-tabs-slider>
        <v-tab v-for="(i,index) in tabsFiltradas" :key="index" @click="$router.push(i.rota)">
            <v-icon class="icon-home">{{i.icon}}</v-icon>&#x9;{{ i.nome }}</v-tab>
        <v-tabs-items>
            <v-card class="elevation-0" flat>
                <transition name="component-fade" mode="out-in">
                    <router-view></router-view>
                </transition>
            </v-card>
        </v-tabs-items>
    </v-tabs>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	data(){
		return{
            tab: null,
            tabs:[]
		}
    },
    updated()
    {
        if(this.$route.name == "menuprotaxi")
        {
            this.$router.push(`/${this.tabsFiltradas[0].rota}`)
            this.tab = 0
        }
    },
	mounted()
	{
        this.tabs = this.$route.meta.subroutes
        this.$router.push(`/${this.tabsFiltradas[0].rota}`)

        //console.log(this.$route)
    },
    computed:{
        ...mapGetters(['getChildren']),
        getTabs()
        {
            return this.getChildren.filter( m => this.tabs.find( t => t == m.rota && m.acoes.filter( a => a.status == true ).length > 0 ) )
        },
        tabsFiltradas()
        {
            return ["ligar", "resumo" ].map( _ => this.getTabs.find( b => b.rota == _ ) ).filter( _ => _)
        }
    }
}
</script>

<style scoped>
	.icon-home{
		font-size:1.5em;
		margin-right:10px;
	}
</style>




// WEBPACK FOOTER //
// src/components/user/Menuprotaxi.vue